export const ImageConstants = {
  User: require("../../images/user-icon.png"),
  Text: require("../../images/txt-icon.png"),
  Audio: require("../../images/audio-icon.png"),
  Video: require("../../images/video-icon.png"),
  Doc: require("../../images/doc-icon.png"),
  Ppt: require("../../images/ppt-icon.png"),
  Excel: require("../../images/excel-icon.png"),
  Pdf: require("../../images/pdf-icon.png"),
  Zip: require("../../images/zip-icon.png"),
  ZipFileView: require("../../images/zip.png"),
  ZipThumbnail: require("../../images/zip-thumbnail.jpg"),
  File: require("../../images/file.png"),
  Pic: require("../../images/image-icon.png"),
  NoData: require("../../images/nodata.jpg"),
  Users: require("../../images/users_icon.png"),
  Encryption: require("../../images/encryption.gif"),
  NoImage: require("../../images/no-image.png"),
  ExpiredLink: require("../../images/expiredLink.png"),
  NoThumbNail: require("../../images/noThumbnail.jpg"),
  Invisible: require("../../images/invisible-icon.png"),
  Visible: require("../../images/visible_icon.png"),
  Page404: require("../../images/404.png"),
};
